<template>
  <div>
    <template v-if="judgedCompetitionsGrouped.length">
      <div
        v-for="lvl in judgedCompetitionsGrouped"
        :key="lvl.competitionLevel.name"
      >
        {{ lvl.competitionLevel.name }} ({{ lvl.difficulties }})
      </div>
    </template>
    <template v-else>
      {{
        $t(
          "people:personPage.rolesInShowsTab.competitions.noAssignement.text",
          "no assignment to specific class"
        )
      }}
    </template>
  </div>
</template>
<script>
import { sortBy } from "lodash-es";
import { useCompetitionLevelHelper } from "@composables/masterdata/competitions/competitionLevels";
import { useDifficultyLevelHelper } from "@composables/masterdata/competitions/difficultyLevels";
export default {
  name: "AppShowPersonJudgedCompetitions",
  props: {
    judgedCompetitions: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useCompetitionLevelHelper(),
      ...useDifficultyLevelHelper()
    };
  },
  computed: {
    judgedCompetitionsGrouped() {
      const levelsGroup = this.judgedCompetitions.reduce(
        (arr, { competition_level_id, difficulty_level_id }) => {
          if (!arr[competition_level_id]) arr[competition_level_id] = [];
          if (!difficulty_level_id) return arr;
          arr[competition_level_id].push(difficulty_level_id);
          return arr;
        },
        {}
      );
      const grouped = Object.entries(levelsGroup)
        .map(([level, difficulties]) => {
          level = this.getCompetitionLevelFromMaster(level);
          difficulties = difficulties
            .reduce((diffs, diff) => {
              diffs.push(this.getDifficultyLevelFromMaster(diff));
              return diffs;
            }, [])
            .sort((a, b) => (a.rank > b.rank ? 1 : -1));
          if (difficulties.length == 0) return false;
          return {
            competitionLevel: level,
            difficulties: difficulties.map(diff => diff.displayName).join(", ")
          };
        })
        .filter(Boolean);

      return sortBy(grouped, "competitionLevel.rank");
    }
  }
};
</script>
